import i18next from 'util/i18n';

export const UNKNOWN_ERROR_MSG = i18next.t('errors.system');
export const LOST_CONNECTION_MSG = i18next.t('errors.lostServerWait');
export const LOST_CONNECTION_TOTALY_MSG = i18next.t('errors.lostServer');
export const SERVER_ERROR_MSG = i18next.t('errors.callServerLost');
export const SERVER_NOT_RESPONSE_MSG = i18next.t('errors.callServerNotResponse');
